import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyPlanReportPageRedirectRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-redirect',
	path: '/secure/PortfolioReportView.jspa',
};
